module.exports = __webpack_public_path__ + "static/media/study 210623.805a5a67.png";